import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';

const messages = defineMessages({
  TEST_ACCOUNT_EXPIRED: {
    id: 'CompanyExpiredInformation.TEST_ACCOUNT_EXPIRED',
    defaultMessage: 'Kostenloser Zeitraum abgelaufen',
  },
  CONTACT_SALES: {
    id: 'CompanyExpiredInformation.CONTACT_SALES',
    defaultMessage: 'Wenn Sie tele-LOOK weiterhin nutzen möchten, setzen Sie sich mit Ihrer Ansprechperson oder {emailLink} in Verbindung.',
  },
  UNLOCK_NOW: {
    id: 'CompanyExpiredInformation.UNLOCK_NOW',
    defaultMessage: 'Jetzt freischalten',
  },
});

function CompanyExpiredInformation(props) {
  const { intl: { formatMessage }, isAdmin, id } = props;
  
  const mailSubject = encodeURIComponent('Testzeitraum abgelaufen');
  const mailBody = encodeURIComponent('Hallo tele-LOOK Team,\n\nunser Testzeitraum ist abgelaufen und wir möchten tele-LOOK gerne weiterhin nutzen.\n\nBitte setzen Sie sich mit uns in Verbindung.\n\n');
  const mailToLink = `mailto:sales@tele-look.com?subject=${mailSubject}&body=${mailBody}`;

  const emailLink = (
    <a 
      href={mailToLink}
      style={{ color: 'var(--primary-color, #0275d8)', textDecoration: 'none', fontWeight: 'bold' }}
    >
      sales@tele-look.com
    </a>
  );

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '80vh',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: '24px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
        padding: '50px 40px',
        maxWidth: '550px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid rgba(255, 255, 255, 0.5)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: 'var(--primary-color, #0275d8)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '36px',
          margin: '0 auto 30px auto',
          boxShadow: '0 8px 20px rgba(2, 117, 216, 0.3)'
        }}>
          <i className="fa fa-info" />
        </div>
        
        <h2 style={{ 
          color: '#1f2937', 
          fontSize: '28px', 
          fontWeight: '700', 
          marginBottom: '20px', 
          letterSpacing: '-0.5px' 
        }}>
          {formatMessage(messages.TEST_ACCOUNT_EXPIRED)}
        </h2>
        
        <p style={{ 
          color: '#6b7280', 
          fontSize: '16px', 
          lineHeight: '1.6',
          marginBottom: isAdmin ? '30px' : '0'
        }}>
          {formatMessage(messages.CONTACT_SALES, { emailLink })}
        </p>

        {isAdmin && (
          <div style={{ marginTop: '30px' }}>
            <Link 
              to={`/company/${id}/payment`}
              className="lh-btn lh-btn-primary"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 30px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '50px',
                boxShadow: '0 4px 14px rgba(2, 117, 216, 0.3)',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
            >
              {formatMessage(messages.UNLOCK_NOW)}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default injectIntl(CompanyExpiredInformation);
